// Polyfills for IE11 and below.
import 'core-js';
import 'raf/polyfill';
import './global.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import { CookiesProvider } from 'react-cookie';

import 'bootstrap/dist/css/bootstrap.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

import App from './components/App/App';
import store from './store';
import { consumeFlashMessages } from './actions/toastActions';

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <CookiesProvider>
        <App />
      </CookiesProvider>
      <ReduxToastr preventDuplicates closeOnToastrClick />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root') as HTMLElement,
);

(store.dispatch as any)(consumeFlashMessages());
